import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, ListGroup, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Example_SimpleRAG } from '../components/tutorials/Example_SimpleRAG';
import { LLMChat } from '../components/tutorials/LLMChat';
import { QuickStart } from '../components/tutorials/QuickStart';
import {
  isMobile
} from "react-device-detect";


export default function ExamplesScreen() {

  const navigate = useNavigate();

  const [view, setView] = useState('quick-start');
  const [showNav, setShowNav] = useState(false);
  const [mobileLike, setMobileLike] = useState(isMobile);

  useEffect(() => {
    const handleResize = () => {
      try {
        setMobileLike(isMobile || window.innerWidth < 992);
      } catch (e) {
        setMobileLike(isMobile);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nav = useMemo(() => ([
    {
      id: 'quick-start',
      title: 'Quick Start', 
      description: 'Create a quick workflow', 
      url: 'quick-start'
    },
    {
      id: 'llm-chat',
      title: 'LLM Chat', 
      description: 'Chat with an LLM with a data snippet', 
      url: 'llm-chat'
    },
  ]), []);

  const flatNav = useMemo(() => {
    const items = [];
    nav.forEach(section => {
      items.push({ ...section, section: section.title });
    });
    return items;
  }, [nav]);

  const currentIndex = useMemo(() => flatNav.findIndex(i => i.id === view), [flatNav, view]);
  const prevItem = currentIndex > 0 ? flatNav[currentIndex - 1] : null;
  const nextItem = currentIndex >= 0 && currentIndex < flatNav.length - 1 ? flatNav[currentIndex + 1] : null;
  
  const renderContent = () => {
    switch (view) {
      case 'quick-start':
        return <QuickStart />;
      case 'llm-chat':
        return <LLMChat />
       
      default:
        return (
          <div style={{ padding: '16px' }}>
            <p className='h5' style={{ margin: 0 }}>Content coming soon.</p>
          </div>
        );
    }
  };

  return (

    <>

    {mobileLike && (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', position: 'sticky', top: 0, zIndex: 1030, background: '#fff', borderBottom: '1px solid #eee' }}>
        <Button variant="outline-secondary" size="sm" onClick={() => setShowNav(true)}>Menu</Button>
        <div className='h5' style={{ margin: 0 }}>Examples</div>
      </div>
    )}


    <Row className="g-0 flex-md-nowrap" style={{ alignItems: 'stretch' }}>
      <Col md="auto" className={mobileLike ? 'd-none' : 'd-block'} style={{ flex: '0 0 260px', maxWidth: '260px', minWidth: '220px', borderRight: '1px solid #eee', maxHeight: '100vh', overflow: 'scroll' }}>
      <div className="sidebar" style={{ position: 'sticky', top: 0, padding: '16px 12px' }}>
          <div className='text-uppercase text-muted' style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.04em', margin: '8px 12px' }}>
              Tutorials
          </div>
        <ListGroup variant="flush">
          {nav.map((ex, idx) => (
            <ListGroup.Item
              key={idx}
              action
              active={view === ex.url}
              onClick={() => setView(ex.url)}
              style={{
                border: 'none',
                borderRadius: 0,
                cursor: 'pointer',
                fontWeight: 600,
                backgroundColor: view === ex.id ? '#667eea' : 'transparent',
                color: view === ex.id ? '#fff' : 'inherit',
                borderBottom: '1px solid #eee',
              }}
            >
              {ex.title}
            </ListGroup.Item>
          ))}
        </ListGroup>
        </div>
      </Col>
      <Col style={{ flex: '1 1 auto', minWidth: 0, padding: '16px', marginLeft:'20px', marginRight:'20px', marginTop:'20px', marginBottom:'20px' }}>
        {renderContent()}
        
      </Col>
    </Row>

    {mobileLike && showNav && (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 2000, pointerEvents: 'auto' }}>
        <div
          className="sidebar"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '82vw',
            maxWidth: '340px',
            height: '100vh',
            background: '#fff',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            overflowY: 'auto',
            padding: '16px 12px',
            borderRight: '1px solid #eee'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 8px', marginBottom: '8px' }}>
            <div className='h5' style={{ margin: 0 }}>Examples</div>
            <Button variant="light" size="sm" onClick={() => setShowNav(false)}>Close</Button>
          </div>
          <ListGroup variant="flush">
            {nav.map((ex, idx) => (
              <ListGroup.Item
                key={idx}
                action
                active={view === ex.url}
                onClick={() => { setView(ex.url); setShowNav(false); }}
                style={{
                  border: 'none',
                  borderRadius: 0,
                  cursor: 'pointer',
                  fontWeight: 600,
                  backgroundColor: view === ex.id ? '#667eea' : 'transparent',
                  color: view === ex.id ? '#fff' : 'inherit',
                  borderBottom: '1px solid #eee',
                }}
              >
                {ex.title}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>
    )}
    
    
    
    </>

  );
}